import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import SearchBar from '../../../SearchBar'
import VehicleSelectBox from '../../../dump/menuComponents/VehicleSelectBox'
import { vehicleReportFields } from '../ReportsHelpers'
import CategoryItem from '../../../dump/menuComponents/CategoryItem'
import CustomButton from '../../../CustomButton'
import { isInternalUser } from '../../../helpers/constants'

import { getUsers } from '../../../../action/ClientActions'
import { getDevicesList } from '../../../../action/DeviceActions'
import { constants } from '../../../helpers/constants'
import { getCustomReports, addCustomReport } from '../../../../action/ReportsActions'

const NewReportModal = (props) => {
    const { user, company, userReports, onHide, loaderModal, toggleLoaderModal } = props;
    const userRole = user.roles[0];
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'reportsPage.newReportModal' });
    const [step, setStep] = useState(2);
    const [type, setType] = useState('vehicle');
    const [fields, setFields] = useState(['vehicle_name']);
    const [name, setName] = useState('');
    const [vehicles, setVehicles] = useState([]);
    const [totalVehicles, setTotalVehicles] = useState([]);
    const [users, setUsers] = useState([]);
    const [totalUsers, setTotalUsers] = useState([]);
    const [userSearch, setUserSearch] = useState('');
    const [errors, setErrors] = useState([]);
    const [customUserReports, setCustomUserReports] = useState([]);

    const isProd = document.location.hostname === 'fleet.roscolive.com';
    const DV7access = (!isProd && !['S3 buckets partner'].includes(company.partner)) || (isProd && (['DV7 Rosco Testing'].includes(company.partner) || [2101, 2774, 2565].includes(company.company_id)));
    const customDV7Access = isProd && [669, 1059, 1053, 3801].includes(company.company_id);

    useEffect(() => {
        getReportOptions();
        if (!userReports.length) {
            getAllCustomReports()
        }
        else {
            setCustomUserReports(userReports)
        }
    }, [])

    const getReportOptions = () => {
        let reqArray = [];
        reqArray.push(getDevicesList(company.company_id));
        if (['system_admin', 'customer_service', 'partner', 'fleet_manager', 'custom_user', 'group_manager', 'sales_demo', 'custom_partner'].indexOf(userRole) > -1) {
            reqArray.push(getUsers(userRole, company))
        }
        toggleLoaderModal(true);
        Promise.all(reqArray)
            .then(res => {
                let devices = res[0].data.response.devices;
                let users = [];
                if (res.length > 1) {
                    users = res[1].data.response.users.filter(user => user.email !== props.user.email);
                }
                setTotalVehicles(devices)
                setTotalUsers(users)
                setVehicles(devices.map(vehicle => vehicle.device_id))
                toggleLoaderModal(false);
            })
            .catch(err => {
                toggleLoaderModal(false);
                toastr.error(t('toastrUnknownError'));
            });
    }

    // FWSD-5293
    const getAllCustomReports = () => {
        const { id, email } = user
        toggleLoaderModal(true)
        getCustomReports(email, company.company_id)
            .then(res => {
                const customReports = res.data.response.filter(({ owner_id }) => owner_id === id)
                setCustomUserReports(customReports.map(({ name }) => name))
                toggleLoaderModal(false)
            })
            .catch(err => {
                toggleLoaderModal(false)
                toastr.error(t('errorGettingReports'))
            })
    }

    const selectType = (type) => {
        const newFields = [...fields];
        if (type === 'vehicle') {
            newFields.push('vehicle_name');
        }
        else {
            newFields.push('driver_name');
        }
        setStep(2)
        setType(type)
        setFields(newFields)
    }

    const setField = (field) => {
        const newFields = [...fields]
        if (newFields.includes(field)) {
            newFields.splice(newFields.indexOf(field), 1)
        }
        else {
            newFields.push(field);
        }

        setFields(newFields)
        setErrors([])
    }

    const setSelectedVehicles = (vehicles) => {
        setVehicles(vehicles)
        setErrors([])
    }

    const setUser = (user) => {
        const newUsers = [...users]
        if (newUsers.includes(user)) {
            newUsers.splice(newUsers.indexOf(user), 1)
        }
        else {
            newUsers.push(user);
        }

        setUsers(newUsers)
        setErrors([])
    }

    const selectAllUsers = (e) => {
        let users = []
        if (e.target.checked) {
            users = totalUsers.map(user => {
                return user.email
            })
        }
        else {
            users = []
        }
        setUsers(users)
        setErrors([])
    }

    const nextStep = () => {
        if (!name) {
            setErrors({ ...errors, name: t('errorEnterVameReport') })
        }
        else if (!name.trim() || !/^[a-zA-Z0-9 ]+$/.test(name)) {
            setErrors({ ...errors, name: t('errorEnterValidName') })
        }
        else if (customUserReports.length && customUserReports.includes(name)) {
            setErrors({ ...errors, name: t('errorReportExists') })
        }
        else if (fields.length <= 1) {
            setErrors({ ...errors, fields: t('errorSelectField') })
        }
        else if (!totalVehicles.length) {
            setErrors({ ...errors, fields: t('errorAddCompanyDevice') })
        }
        else {
            setStep(3)
        }
    }

    const goToShareOptions = () => {
        if (!vehicles.length) {
            setErrors({ ...errors, assets: t('errorSelectVehicle') })
        }
        else {
            setStep(4)
        }
    }

    const addReport = () => {
        if (vehicles.length === 0) {
            setErrors({ ...errors, assets: t('errorSelectVehicle') })
        }
        else {
            const data = {
                name: name,
                type: type,
                fields: fields,
            }
            if (vehicles.length !== totalVehicles.length) {
                data.vehicles = vehicles
            }
            if (users.length) {
                data.users = users
            }
            toggleLoaderModal(true);
            addCustomReport(data)
                .then(res => {
                    toggleLoaderModal(false);
                    props.goToCustomReports();
                    toastr.success(t('toastrCreatedReport'))
                })
                .catch(err => {
                    toggleLoaderModal(false);
                    toastr.error(t('errorCreatingReport'))
                });
        }
    }

    const allUsersChecked = users.length === (totalUsers && totalUsers.length);

    return (
        <Modal
            size='lg'
            show
            onHide={onHide}
            className="reports-modal modal-lg-size"
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('titleNewReport') + (step > 2 ? (' - ' + t(type)) : '')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="new-report-body">
                    {step === 1 &&
                        <div className='type-select'>
                            <CategoryItem
                                text={t('textVehicle/Fleet')}
                                onClick={() => selectType('vehicle')}
                                withArrow
                            />
                            <CategoryItem
                                text={t('textDriver')}
                                onClick={() => selectType('driver')}
                                withArrow
                            />
                        </div>
                    }
                    {step === 2 &&
                        <div className='fields-select'>
                            <div className='report-info'>
                                <h4 className='category-title'>
                                    {t('titleReportName')}
                                </h4>
                                <input value={name} type='text' placeholder={t('titleReportName')} className={'vehicle-search report-input' + (errors['name'] ? ' error' : '')}
                                    onChange={(e) => setName(e.target.value)}
                                    onFocus={() => setErrors([])}
                                />
                                <div className={'error-msg'}>{errors['name']}</div>
                            </div>
                            <div className='error-msg text-center'>{errors['fields']}</div>
                            {vehicleReportFields(DV7access, customDV7Access).map(category =>
                                <div className='fields-category' key={category.name}>
                                    <h4 className='category-title'>{i18n.t(`constants.vehicleReportCategoryName.${category.name.replace(/\s/g, "_")}`)}</h4>
                                    <div className='category-fields'>
                                        {category.fields.map(field => {
                                            // Only for Tenna and internal users (FWSD-7355)
                                            // if (!(user?.partner_company_name === "TENNA LLC" || user?.company_name === "Tenna LLC" || isInternalUser(userRole)) && field.fieldName === 'camera_block') {
                                            //     return;
                                            // }
                                            return (<div className='field-container' key={field.name}>
                                                <input type='checkbox'
                                                    readOnly={field.defaultSelected}
                                                    onChange={() => !field.defaultSelected && setField(field.fieldName)}
                                                    checked={fields.includes(field.fieldName)}
                                                />
                                                <span className='field'>{i18n.t(`constants.vehicleReportFieldsName.${field.name.replace(/\s/g, "_")}`)}</span>
                                            </div>)
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                    {step === 3 &&
                        <div className='details-select'>
                            <h4 className='category-title'>
                                {t('titleReportOptions')}
                            </h4>
                            <div className='modal-column'>
                                {totalVehicles.length > 0 &&
                                    <VehicleSelectBox
                                        vehicles={totalVehicles}
                                        selectedVehicleIds={vehicles}
                                        error={errors['assets']}
                                        onToggle={setSelectedVehicles}
                                    />
                                }
                            </div>
                        </div>
                    }
                    {step === 4 &&
                        <div className='report-category details-select'>
                            <h4 className='category-title'>
                                {t('titleShareOptions')}
                            </h4>
                            <div className='modal-column select-box'>
                                <div className='select-box-header'>
                                    <div className='column-title'>{t('titleUsers')}</div>
                                    <input type='checkbox' checked={allUsersChecked} onChange={selectAllUsers} className='select-all-checkbox' />
                                    <span className='select-all-label'>{t('selectAll') + users.length + t('textSelected')}</span>
                                </div>
                                <SearchBar term={userSearch} onSearch={(e) => setUserSearch(e.target.value)} />
                                <div className='select-box-body'>
                                    <div className={'asset-select' + (allUsersChecked ? ' disabled' : '')}>
                                        {totalUsers && totalUsers.map((user) => {
                                            let name = user.first_name + ' ' + user.last_name;
                                            if (name && (!userSearch || name.toLowerCase().includes(userSearch.toLowerCase()))) {
                                                return (
                                                    <div className='asset-select-wrapper' key={user.id}>
                                                        <input type='checkbox' checked={users.includes(user.email)} onChange={() => setUser(user.email)} />
                                                        <span className='asset-name'>{name + ' - ' + i18n.t(`constants.roleNames.${constants.roleNames[user.roles[0]].replace(/\s/g, "_")}`)}</span>
                                                    </div>
                                                )
                                            }
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                {step === 2 && <>
                    <CustomButton
                        variant='primary'
                        onClick={nextStep}
                    >
                        {t('btnNext1')}
                    </CustomButton>
                </>}
                {step === 3 && <>
                    <CustomButton
                        variant='primary-outline'
                        onClick={() => setStep(2)}
                    >
                        {t('btnBack2')}
                    </CustomButton>
                    {['user', 'partner_view'].indexOf(userRole) > -1 ?
                        <CustomButton
                            variant='primary'
                            onClick={() => addReport()}
                        >
                            {t('btnAdd2')}
                        </CustomButton> :
                        <CustomButton
                            variant='primary'
                            onClick={goToShareOptions}
                        >
                            {t('btnNext2')}
                        </CustomButton>
                    }
                </>}
                {step === 4 && <>
                    <CustomButton
                        variant='primary-outline'
                        onClick={() => setStep(3)}
                    >
                        {t('btnBack3')}
                    </CustomButton>
                    <CustomButton
                        variant='primary'
                        onClick={() => addReport()}
                    >
                        {t('btnAdd3')}
                    </CustomButton>
                </>}
            </Modal.Footer>
            {loaderModal}
        </Modal>
    )
}

export default connect(
    state => ({
        user: state.user.user,
        company: state.company.company,
        loaderModal: state.loader.loaderModal,
    }),
    dispatch => ({
        toggleLoaderModal: (show) => {
            dispatch({ type: 'TOGGLE_LOADER_MODAL', payload: show });
        }
    }),
)(NewReportModal);
